import type { Logger } from '@datadog/browser-logs';
import { datadogLogs } from '@datadog/browser-logs';

import { LOGGER_TYPE } from 'api/types';

const ddLogger = datadogLogs.getLogger(LOGGER_TYPE.AGENT_STREAM);

export const agentStreamLogger: Pick<Logger, 'info' | 'error'> =
  process.env.NODE_ENV === 'development'
    ? {
        info: (message: string, context: Record<string, unknown>) => {
          console.log(message, context);
        },
        error: (message: string, context: Record<string, unknown>) => {
          console.error(message, context);
        },
      }
    : ddLogger!;

// Connection key format for tracking projection state
export const getConnectionKey = (
  accountId: string,
  projectId: string,
  branchId: string,
) => `${accountId}-${projectId}-${branchId}`;

// Default sequence ID when none is available
export const DEFAULT_SEQUENCE_ID = '0';
